export default "__VITE_ASSET__a01bcb07__"